import { mapActions } from "../reducer";

import { MapState } from '../../types';

export const updateFocusPoint = (value: MapState['focusPoint']) => mapActions.setFocusPoint(value);
